import { useCallback, useEffect, useState } from "react";
import { setLoading, unsetLoading } from "../../../../store/loading/loading.slice";
import { useDispatch, useSelector } from "react-redux";
import { MENU_RENDER_VIEW_ENUM } from "./enum.menu";
import { MenuApi, menuState } from "../../../../api/menu/menu.api";
import { alertActive, alertError, alertSuccess } from "../../../../components/alert/swal";
import { flattenMenu } from "./util";
import { RootState } from "../../../../store/store";
import { checkPermission } from "../../../../utils/app.utils";
import { useTranslation } from "react-i18next";

export const ManageState = () => {
    const { t } = useTranslation();


    // const profileReducer = useSelector((state: RootState) => state.profile.profile);
    // const permission: any[] = profileReducer?.permission || [];
    // const checkPermit = checkPermission('website_structure_menu', permission);

    const profileReducer = useSelector((state: RootState) => state.profile.profile);
    const permission: any[] = profileReducer?.permission || [];
    const checkPermit = checkPermission('WEBSITE_STRUCTURE_MENU_HEADER', permission);

    const dispatch = useDispatch();
    const [menu_data, set_menu_data] = useState<any[]>([]);
    const [id_menu, set_id_menu] = useState<number[]>([]);
    const [menu_all_data, set_menu_all_data] = useState<any[]>([]);

    const [searchMenu, setSearchMenu] = useState<string>("");
    const [showModal, setShowModal] = useState<string>("");
    const [selected_id_menu, set_selected_id_menu] = useState<number | null>(null);
    const [menu_detail, set_menu_detail] = useState<{
        menu_name: string,
        menu_link: string,
        menu_status_open: string;
        parent_menu_name?: string;
        id_menu_ref: number | null;
        group_menu: string;
        is_edit?: boolean;
        is_not_show: boolean;
    }>({
        menu_name: "",
        menu_link: "",
        menu_status_open: MENU_RENDER_VIEW_ENUM.CURRENT_TAB,
        parent_menu_name: "",
        id_menu_ref: null,
        group_menu: "",
        is_not_show: false
    });
    const handleChangeMenuDetail = (field: string, value: string | boolean) => {
        set_menu_detail((prev) => ({ ...prev, [field]: value }))
    }
    const handleCloseModal = () => {
        setShowModal("");
        if (selected_id_menu) {
            handleGetDetailMenu(selected_id_menu);
        }
    }

    const handleGetMenuData = useCallback(async () => {
        dispatch(setLoading());
        let query: { keyword?: string } = {}
        if (searchMenu) query = { ...query, keyword: searchMenu }
        await MenuApi.getMenuTree(query).then((res) => {
            if (res.status < 300) {
                const data: any[] = res.data?.data || [];
                const menu_map_data = data?.map((list) => {
                    return {
                        ...list,
                        is_not_show: list?.is_not_show ? true : false
                    }
                })
                const menu_list = flattenMenu(data);
                set_menu_all_data(menu_list);
                set_menu_data(menu_map_data || [])
            }
        }).catch((err) => console.log(err)).finally(() => {
            dispatch(unsetLoading());
        })
    }, [searchMenu])
    const handleGetDetailMenu = async (id_menu: number) => {
        dispatch(setLoading())
        set_selected_id_menu(id_menu);
        handleOpenMenu(id_menu);
        await MenuApi.getDetailMenu(id_menu).then(async (res) => {
            if (res.status < 300) {
                const data = res.data?.data || null;
                const id_menu_ref = data?.id_menu_ref;
                let parent_menu: { menu_name: string, id_menu: number | null } = { id_menu: null, menu_name: "" }
                if (id_menu_ref) {
                    parent_menu = await MenuApi.getDetailMenu(id_menu_ref).then((res) => res?.data?.data || "");
                }
                set_menu_detail((prev) => ({
                    ...prev,
                    menu_name: data?.menu_name || "",
                    menu_link: data?.menu_link || "",
                    parent_menu_name: parent_menu?.menu_name,
                    menu_status_open: data?.menu_status_open,
                    id_menu_ref: parent_menu.id_menu || null,
                    is_edit: data?.is_edit ? true : false,
                    is_not_show: data?.is_not_show ? true : false,
                    group_menu: data?.group_menu || ""
                }))
            }
        }).catch((err) => console.log(err)).finally(() => {
            dispatch(unsetLoading());
        })
    }

    const handleUpdateMenu = async (id_menu: number) => {
        dispatch(setLoading());
        const body: menuState = {
            id_menu_ref: menu_detail.id_menu_ref,
            menu_link: menu_detail.menu_link,
            menu_name: menu_detail.menu_name,
            menu_status_open: menu_detail.menu_status_open,
            group_menu: menu_detail.group_menu || null,
            is_not_show: menu_detail.is_not_show
        }
        await MenuApi.update(id_menu, body).then((res) => {
            if (res.status < 300) {
                setShowModal("");
                handleGetDetailMenu(id_menu);
                handleGetMenuData();
                set_selected_id_menu(null);
                set_id_menu([]);
                alertSuccess(t("อัพเดตเมนู"), t("อัพเดตเมนู สำเร็จ"));
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    const handleDeleteMenu = (id_menu: number) => {
        alertActive(t("ลบเมนู"), t("ท่านต้องการลบเมนูนี้?"), undefined, undefined, async () => {
            dispatch(setLoading());
            await MenuApi.delete(id_menu).then((res) => {
                if (res.status < 300) {
                    handleGetMenuData();
                    set_selected_id_menu(null);
                    set_id_menu(prev => prev.filter((x) => x !== id_menu));
                    alertSuccess(t("ลบเมนู"), t("ลบเมนู สำเร็จ"))
                }
            }).catch((err) => {
                console.log(err);
                alertError(t("ลบเมนู"), t("ลบเมนู ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading())
            })
        })
    }

    const handleCreateMenu = async () => {
        const body: menuState = {
            id_menu_ref: menu_detail.id_menu_ref,
            menu_link: menu_detail?.menu_link,
            menu_name: menu_detail?.menu_name,
            menu_status_open: menu_detail?.menu_status_open,
            group_menu: menu_detail?.group_menu || null,
            is_not_show: menu_detail?.is_not_show
        }
        dispatch(setLoading());
        await MenuApi.createdMenu(body).then((res) => {
            if (res.status < 300) {
                handleGetMenuData();
                setShowModal("");
                alertSuccess(t("สร้างเมนู"), t("สร้างเมนู สำเร็จ"));
            }
        }).catch((err) => {
            console.log(err)
            alertError(t("สร้างเมนู"), err?.response?.data?.message || t("สร้างเมนู ไม่สำเร็จ"));
            handleGetMenuData();
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    const handleOpenMenu = (id_menu_value: number) => {
        if (id_menu_value === selected_id_menu) {
            set_selected_id_menu(null);
        }
        const has_id: boolean = id_menu.some((x) => x === id_menu_value);
        if (has_id) {
            set_id_menu((prev) => prev?.filter((x) => id_menu_value !== x))
        } else {
            set_id_menu((prev) => ([...prev, id_menu_value]))
        }
    }

    useEffect(() => {
        handleGetMenuData();
    }, [handleGetMenuData])

    return {
        selected_id_menu,
        handleOpenMenu,
        handleChangeMenuDetail,
        handleGetDetailMenu,
        menu_detail,
        menu_data,
        id_menu,
        handleCloseModal,
        showModal,
        setShowModal,
        handleUpdateMenu,
        menu_all_data,
        handleDeleteMenu,
        set_menu_detail,
        set_selected_id_menu,
        handleCreateMenu,
        setSearchMenu,
        checkPermit
    }
}